import { Location } from '@libs/models/locations';
import { request } from '../request';

export async function createLocation(data: CreateLocationData) {
  return request.post('/v2/settings/locations', data);
}

type CreateLocationData = Omit<Location, 'id'>;
